import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

export const AutoHeightAnimation = trigger('autoHeight', [
  transition('void <=> *', []),
  transition(
    '* <=> *',
    [
      style({ height: '{{height}}px' }),
      group([animate('150ms ease-in-out'), query('@switch', animateChild(), { optional: true })]),
    ],
    {
      params: { height: 0 },
    },
  ),
]);
